<template>
  <b-modal id="dashboard-coach-modal" hide-footer :title="`Chọn thông tin`" size="l" :hide-header-close="true"
    no-close-on-backdrop no-close-on-esc>
    <b-container>
      <b-row>
        <b-col cols="12">
          <basic-select label="Chọn Coach" placeholder="Chọn Coach" name="Coach" :options="coaches" :solid="false"
            :required="false" :allowEmpty="true" track-by="value" value-label="text" v-model="coachSelected"
            :value.sync="coachSelected" changeValueByObject data-vv-as="Coaches" :loading="isLoading" />
        </b-col>
        <b-col cols="12">
          <basic-select label="Danh sách Service Package" placeholder="Chọn Service Package" name="servicePackages"
            :solid="false" :required="false" :allowEmpty="true" track-by="value" value-label="text"
            :options="servicePackages" v-model="servicePackageSelected" :value.sync="servicePackageSelected"
            changeValueByObject data-vv-as="Service Package" :loading="isLoadingPackages" />
        </b-col>
      </b-row>
      <div class="d-flex justify-content-end align-items-center mt-4">
        <b-button class="btn btn-light ml-3" @click="handleClose" type="button">
          Đóng
        </b-button>
        <b-button class="btn btn-success ml-3" @click="handleSubmit" type="submit">
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/save.svg" />
          </span>
          Xác nhận
        </b-button>
      </div>
    </b-container>
  </b-modal>
</template>

<script>
import { ONBOARDING } from '../DashboardTrackingEnum.js';

export default {
  name: 'SelectCoachModal',
  props: {
    currentUser: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      coaches: [],
      servicePackages: [],
      coachSelected: null,
      servicePackageSelected: null,
      isLoading: false,
      isLoadingPackages: false,
    };
  },
  methods: {
    handleSubmit() {
      this.$emit('selected-success', {
        coachSelected: this.coachSelected,
        servicePackageSelected: this.servicePackageSelected,
      });
      this.$bvModal.hide('dashboard-coach-modal');
    },

    handleClose() {
      this.$bvModal.hide('dashboard-coach-modal');
    },

    async loadCoaches() {
      this.isLoading = true;
      try {
        const { data } = await this.$api.get(`Courses/CoachInCourse?courseId=${ONBOARDING.ID}`);
        this.coaches = data?.map(c => ({
          text: c.fullName,
          value: c.id,
        })) || [];

        // Auto-fill: nếu currentUser là coach trong danh sách thì tự động chọn
        const matchedCoach = this.coaches.find(c => c.value === this.currentUser?.id);
        if (matchedCoach) {
          this.coachSelected = matchedCoach;
        }
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.isLoading = false;
      }
    },

    async loadServicePackages() {
      this.isLoadingPackages = true;
      try {
        var data = await this.$api.get(`/servicePackage/all?status=0`);
        this.servicePackages = data?.map(s => ({
          text: s.name,
          value: s.id,
        })) || [];
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.isLoadingPackages = false;
      }
    },
  },

  async mounted() {
    await Promise.all([this.loadCoaches(), this.loadServicePackages()]);
    this.$bvModal.show('dashboard-coach-modal');
  },
};
</script>
